module.exports = __webpack_public_path__ + "static/media/amenity-games-room.6f88a757.svg";